import React, { useState, useRef, Fragment } from 'react';

import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';

import { toastShow } from '../../../../Base/Services/ToastService';
import Loader from '../../../../Base/Components/Loader/Loader';

import { agregarRol } from '../../../../API/IT/Roles/RolesRequests';

export const AgregarRolModal = () => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({});
    const [rolDialog, setRolDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const addRol = async () => {
        setLoading(true);
        const r = await agregarRol({
            Rol: formik.values.Rol,
            Description: formik.values.Description
        });
        toastShow(toast, 'success', 'Agregado', `Se guardo el rol ${formData.Rol}`);
        setLoading(false);
    }
    const openNew = () => {
        setRolDialog(true);
    }

    const hideDialog = () => {
        setRolDialog(false);
    }

    const formik = useFormik({
        initialValues: {
            Rol: '',
            Description: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.Rol) {
                errors.Rol = 'El rol es requerido.';
            }

            return errors;
        },
        onSubmit: async (data) => {

            if (isFormFieldValid) {
                setFormData(data);
                await addRol();
            } else {
            }
        }
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <Fragment>
            <Loader loading={loading} />
            <Button icon="pi pi-plus" severity="success" onClick={openNew} />
            <Toast position="bottom-right" ref={toast}></Toast>
            <Dialog visible={rolDialog} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '50vw' }} onHide={hideDialog}>
                <div style={{ width: '100%', margin: 'auto' }}>
                    <h2>Nuevo Rol</h2>
                    <form onSubmit={formik.handleSubmit} className="p-fluid">
                        <div className="field" style={{ marginTop: 30 }}>
                            <span className="p-float-label">
                                <InputText id="Rol" name="Rol" value={formik.values.Rol} onChange={formik.handleChange} 
                                    autoFocus className={classNames({ 'p-invalid': isFormFieldValid('Rol') })} />
                                <label htmlFor="Rol" className={classNames({ 'p-error': isFormFieldValid('Rol') })}>Rol</label>
                            </span>
                            {getFormErrorMessage('Rol')}
                        </div>
                        <div className="field" style={{ marginTop: 30 }}>
                            <span className="p-float-label">
                                <InputText id="Description" name="Description" value={formik.values.Description} onChange={formik.handleChange} 
                                    className={classNames({ 'p-invalid': isFormFieldValid('Description') })} />
                                <label htmlFor="Description" className={classNames({ 'p-error': isFormFieldValid('Descripcion') })}>Description</label>
                            </span>
                            {getFormErrorMessage('Description')}
                        </div>
                        
                        <div className="p-dialog-footer">
                            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                            <Button type='submit' label="Save" icon="pi pi-check" className="p-button-text" />
                        </div>
                    </form>
                </div>
            </Dialog>
        </Fragment>
    );

}

export default AgregarRolModal;